import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { getServiceDeliverableMasterListUrl, insertUpdatServiceDeliverableMasterListUrl, GET_SERVICE_DELIVERABLE_MASTER_LIST, INSERT_UPDATE_SERVICE_DELIVERABLE_MASTER, headers } from "../../../../utils/constants";

export const getServiceDeliverableMasterList_action = (ExihibitionID, MainServiceID, IsActive) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            MainServiceID: MainServiceID,
            IsActive: IsActive != '' ? IsActive : 1,
        }

        const res = await axiosGet(getServiceDeliverableMasterListUrl, params, headers)

        dispatch({
            type: GET_SERVICE_DELIVERABLE_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdatServiceDeliverableMasterList_action = (ExihibitionID, ServiceDeliverableList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            ServiceDeliverableList: ServiceDeliverableList
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdatServiceDeliverableMasterListUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_SERVICE_DELIVERABLE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}